module.exports = __webpack_public_path__ + "img/face_smile.44173f40.svg";